import React from 'react';
import mixpanel from 'mixpanel-browser';

import { Box, Button } from '@mui/material';

import brookeCagle from './Images/brooke-cagle.jpg';

import NetWorthCard from '../AboutUs/SideBySide/StatsCard/NetWorthCard';

import { headerSectionObj } from '../../constants/Pages/Landing';

import './HeaderSection.css';

export const HeaderSection = ({ isLoggedIn, userId }) => {
  const { title, subtitle, joinUs, checkRates } = headerSectionObj;

  const navigateToPath = isLoggedIn ? '/dashboard' : '/signup';
  const checkRatesOrJoinUs = isLoggedIn ? checkRates : joinUs;

  return (
    <div className="header-section-wrapper">
      <div className="header-section-column header-section-title-section">
        <h1 className="header-section-title">{title}</h1>
        <p className="header-section-subtitle" style={{ marginBottom: '30px' }}>
          {subtitle}
        </p>
        <Button
          sx={{
            borderRadius: '1rem',
            backgroundColor: 'black',
            color: 'white',
            textTransform: 'initial',
            padding: 2.25,
            pl: 5,
            pr: 5,
            m: { lg: 1.5 },
            fontSize: 14,
            fontFamily: 'sans-serif',
            fontWeight: 600,
            textDecoration: 'none',
          }}
          href={navigateToPath}
          onClick={() => {
            mixpanel.track(checkRatesOrJoinUs, { path: '/', distinct_id: userId });
          }}
        >
          {checkRatesOrJoinUs}
        </Button>
      </div>
      <Box className="header-section-column">
        <Box
          component="img"
          src={brookeCagle}
          alt="brookeCagle"
          sx={{
            borderRadius: '1rem',
            objectFit: 'cover',
            position: 'relative',
          }}
          className="brooke-cagle-img"
        />
        <Box
          position="absolute"
          sx={{
            top: { xs: '49%', md: '11.5%' },
            left: { xs: '58%', md: '75%' },
            borderRadius: '1rem',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          <NetWorthCard isVisible={true} />
        </Box>
      </Box>
    </div>
  );
};
